<!--
 * @Description: 申请开票-开票内容
 * @Date: 2025-05-20 15:57:04
-->
<template>
  <BaseForm
    ref="formRef"
    label-position="top"
    scrollToError
    :model="formData"
    :rules="formRules"
    :disabled="disabled"
  >
    <div class="form-dialog__title">
      <h1>开票内容</h1>
    </div>
    <div class="form-dialog__content">
      <BaseFormItem label="开票金额" prop="invoiceAmount">
        <BaseInputNumber
          style="width: 100%"
          placeholder="请输入"
          :controls="false"
          :precision="2"
          :min="0"
          :max="999999999"
          v-model="formData.invoiceAmount"
        ></BaseInputNumber>
      </BaseFormItem>
      <BaseFormItem label="发票类型" prop="invoiceType">
        <BaseSelect
          class="form-dialog__w280"
          type="text"
          placeholder="请输入"
          :options="INVOICE_TYPE"
          v-model="formData.invoiceType"
          @change="onInvoiceTypeChange"
        ></BaseSelect>
      </BaseFormItem>
      <BaseFormItem label="开票类目" prop="itemId">
        <BaseSelect
          v-if="!disabled"
          class="form-dialog__w280"
          type="text"
          placeholder="请选择"
          label-key="itemName"
          value-key="id"
          :init="true"
          :remoteMethod="itemIdRemote"
          v-model="formData.itemId"
          @change="onitemIdChange"
        ></BaseSelect>
        <BaseInput
          v-else
          class="form-dialog__w280"
          type="text"
          :modelValue="formData.itemName"
        />
      </BaseFormItem>
      <BaseFormItem label="结算月度" prop="taskAt">
        <BaseDatePicker
          style="width: 100%"
          placeholder="请选择"
          type="month"
          validate-event
          v-model="formData.taskAt"
        ></BaseDatePicker>
      </BaseFormItem>
    </div>
  </BaseForm>
</template>

<script lang="tsx" setup>
import { ref } from 'vue';
import {
  BaseForm,
  BaseFormItem,
  BaseDatePicker,
  BaseSelect,
  BaseInputNumber,
  BaseInput
} from 'xrk-components';
import { IndustryDetailData } from '@V/invoice/src/data-source/types';
import { industryGetCsoInvoiceCate } from '@V/invoice/src/data-source/apis';
import { INVOICE_TYPE } from '@V/invoice/src/constants';

withDefaults(
  defineProps<{
    disabled: boolean;
  }>(),
  {}
);

const formData = defineModel<IndustryDetailData>();
const formRef = ref(null);

const formRules = {
  invoiceAmount: [{ required: true, message: '请输入', trigger: 'change' }],
  invoiceType: [{ required: true, message: '请选择', trigger: 'change' }],
  itemId: [{ required: true, message: '请选择', trigger: 'change' }]
  // taskAt: [{ required: true, message: '请选择', trigger: 'change' }]
};

/**
 * @description: 获取当前企业关联的发票类目列表
 *               注意：工业角色只能查看本企业类目，其他企业类目不会显示
 *               在禁用状态下，将直接显示类目名称而不进行搜索
 */
const itemIdRemote = () => {
  return industryGetCsoInvoiceCate();
};

const onInvoiceTypeChange = (v, option) => {
  formData.value.invoiceTypeName = option.label;
};
const onitemIdChange = (v, [option]) => {
  formData.value.itemName = option.itemName;
};

defineExpose({
  validate: (...args: any) => formRef.value?.validate(...args)
});
</script>
